import Contact  from "../components/Contact-Us/ContactUs";

export default function ContactUs() {
  return (
    <section className="ContactUs">
      <Contact />
    </section>
  )
}